import { Play } from 'lucide-react';

export default function DemoVideo() {
  return (
    <section id="demo-video" className="section-padding bg-slate-50 dark:bg-slate-900/50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full 
                          bg-primary/10 text-primary text-sm font-semibold mb-4">
            Demo
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 text-slate-900 dark:text-white">
            Ornek Videolari <span className="gradient-text">Kesfedin</span>
          </h2>
          <p className="text-slate-600 dark:text-slate-400 max-w-2xl mx-auto text-lg">
            Maplio ile olusturulmus yuksek cozunurluklu ornekleri izleyin.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative aspect-video rounded-3xl overflow-hidden shadow-2xl 
                          border-4 border-white dark:border-slate-700 bg-slate-200 dark:bg-slate-800">
            <img
              src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&q=80"
              alt="Luks villa uydu gorunumu"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/40">
              <div
                className="w-20 h-20 bg-primary/90 text-white rounded-full flex items-center justify-center shadow-2xl"
                aria-hidden="true"
              >
                <Play className="w-10 h-10 ml-1" fill="currentColor" />
              </div>
            </div>
            <div className="absolute top-4 right-4 rounded-full bg-black/55 text-white text-xs font-semibold px-3 py-1">
              Yakinda
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {[
            { title: 'Luks Villa', img: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=400&q=80' },
            { title: 'Arsa Tanitimi', img: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=400&q=80' },
            { title: 'Site Projesi', img: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&q=80' },
            { title: 'Ticari Bina', img: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&q=80' },
          ].map((video) => (
            <div
              key={video.title}
              className="relative aspect-video rounded-xl overflow-hidden group opacity-90"
            >
              <img
                src={video.img}
                alt={video.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/35" />
              <div className="absolute inset-0 flex items-center justify-center">
                <Play className="w-8 h-8 text-white opacity-80" fill="currentColor" />
              </div>
              <div className="absolute bottom-2 left-2 right-2">
                <span className="text-white text-sm font-medium drop-shadow-md">
                  {video.title}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
